import {useBaseApi} from "../useBaseApi";
import {StatusCodes} from "http-status-codes";

export function useWorkerRepository() {

    const {post, get} = useBaseApi();

    const validateWorker = async (body) => {
        let response =  await post("/worker/validate", body, false);

        if(response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }


    return {validateWorker};
}